import { useState } from "react";
import Box from "@mui/material/Box";
import Tabs, { tabsClasses } from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
// import TabPanel from "@mui/lab/TabPanel";
import { TabPanel, TabContext, TabList } from "@mui/lab";
import { Grid, Typography } from "@mui/material";
import { locationsTab } from "../../data/Tabs";
import { StyledTabs, StyledTab } from "../../styles/TabsStyles";
import Audit from "./Audit/Audit";
import Accompagnement from "./Accompagnement/Accompagnement";
import Formation from "./Formation/Formation";
import Ingenierie from "./Ingenierie/Ingenierie";
import IT from "./IT/IT";

const OptionsTab = () => {
  const [value, setValue] = useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        flexGrow: 1,
        px: { xs: 0, md: 2 },
        alignItems: "center",
        mb: 2,
      }}
    >
      <TabContext value={value}>
        <Box display="flex" justifyContent="center" width="100%">
          <StyledTabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
            sx={{
              [`& .${tabsClasses.scrollButtons}`]: {
                "&.Mui-disabled": { opacity: 0.3 },
              },
            }}
          >
            {locationsTab.map((tab) => {
              return (
                <StyledTab
                  value={tab.value}
                  key={tab.id}
                  icon={tab.icon}
                  label={tab.label}
                />
              );
            })}
          </StyledTabs>
        </Box>

        <TabPanel value="1" index={0}>
          <Accompagnement />
        </TabPanel>
        <TabPanel value="2" index={1}>
          <Audit />
        </TabPanel>
        <TabPanel value="3" index={2}>
          <Formation />
        </TabPanel>
        <TabPanel value="4" index={3}>
          <IT />
        </TabPanel>
        <TabPanel value="5" index={3}>
          <Ingenierie />
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default OptionsTab;
